/**
 * Created by bzm on 2015/9/8.
 */
'use strict';
angular.module("pieceMgr.multiDocDir", ['pieceMgr.multiDocEdit', 'dndLists']).directive("trsFragDocs", ["$modal", "modalDialog", "$timeout", "fragmentService", 'trsSelectDocumentService', function($modal, modalDialog, $timeout, fragmentService, trsSelectDocumentService) {
    return {
        restrict: "E",
        templateUrl: "./editingCenter/website/fragmentManagement/multiDoc/multiDoc_modal.html",
        replace: true,
        scope: {
            jsonObj: "=",
            widgetParams: "=",
            required: "@"
        },
        controller: function($scope, $element) {
            init();
            var addRowOrCol;
            var editJsonNew;
            var docIds = "";
            // var colIndex = "";//声明保存列的下标
            var typeRowOrCols = ""; //声明选取文档是行添加或列添加类型
            //行拖拽初始化开始
            //  getDataJson($scope.widgetId); 
            //行拖拽初始化结束
            /**
             * [insertBefore description] 在此行前插入行
             * @param  {[type]} index [description] 行序号
             * @return {[type]}       [description]
             */
            $scope.insertBefore = function(index) {
                var array = [];
                trsSelectDocumentService.trsSelectDocumentNew(array, $scope.required.split(","), $scope.widgetParams).then(function(data) {
                    $scope.jsonObj.splice(index, 0, data)
                });
            };
            $scope.addRowOrCols = function(rowIndex) {
                var flag = rowIndex === "null";
                var array = rowIndex === "null" ? [] : angular.copy($scope.jsonObj[rowIndex]);
                trsSelectDocumentService.trsSelectDocumentNew(array, $scope.required.split(","), $scope.widgetParams).then(function(data) {
                    if (flag && data.length > 0) {
                        $scope.jsonObj.push(data);
                    } else if (!flag && data.length > 0) {
                        $scope.jsonObj[rowIndex] = data;
                    } else if (!flag && data.length === 0) {
                        $scope.jsonObj.splice(rowIndex, 1);
                    }
                });
                /*var modalInstance = $modal.open({
                    templateUrl: "./editingCenter/website/fragmentManagement/multiDocList/multiDocList-dir.html",
                    scope: $scope,
                    backdrop: false,
                    keyboard: false,
                    windowClass: "defaultClass",
                    controller: function($scope) {
                        if (rowIndex != "null") {
                            $scope.listShow = $scope.jsonObj[rowIndex];
                            addRowOrCol = $scope.$watch("addRowOrCol", function(newValue, oldValue) {
                                if (newValue !== undefined) {
                                    $scope.jsonObj[rowIndex] = newValue;
                                }
                            });
                        } else {
                            addRowOrCol = $scope.$watch("addRowOrCol", function(newValue, oldValue) {
                                if (newValue !== undefined) {
                                    $scope.jsonObj.push(newValue);
                                }
                            });
                        }
                    }
                });*/
            };
            //打开录入模态框结束
            $scope.deleteDoc = function(docid, row, col) {
                modalDialog.confirmModal("删除文章", "确定要删除选中的文章？", function() {
                    $scope.jsonObj[row].splice(col, 1);
                    if ($scope.jsonObj[row].length == 0) {
                        $scope.jsonObj.splice(row, 1);
                    }
                });
                // if (confirm("确认要删除？")) {
                //     $scope.jsonObj[row].splice(col, 1);
                //     if ($scope.jsonObj[row].length == 0) {
                //         $scope.jsonObj.splice(row, 1);
                //     }
                // }
            };
            $scope.editDoc = function(editJson, row, col) {
                var editDoc = $modal.open({
                    templateUrl: "./editingCenter/website/fragmentManagement/multiDoc/multiDoc_doc_edit_dir.html",
                    scope: $scope,
                    backdrop: false,
                    keyboard: false,
                    windowClass: "defaultClass editDocWin",
                    controller: function($scope) {
                        $scope.editJson = editJson; //JSON.stringify(editJson);
                        $scope.editJsonNew;
                        editJsonNew = $scope.$watch("editJsonNew", function(newValue, olsValue) {
                            if (newValue !== undefined) {
                                $scope.jsonObj[row][col] = $scope.editJsonNew;
                            }
                        });
                    }
                });
            };
            //h5拖拽开始
            //拖拽自动增加行
            var promise;
            $scope.addRow = function(event) {
                if (promise) {
                    $timeout.cancel(promise);
                    promise = null;
                }
                promise = $timeout(function() {
                    $scope.jsonObj.push([]);
                }, 10);
                return promise;
            };
            /**
             * [selectAll description] 全选
             * @return {[type]} [description]
             */
            $scope.selectAll = function() {
                if ($scope.jsonObj.length <= 0) return;
                $scope.selectedArray = $scope.selectedArray ? $scope.selectedArray : [];
                if ($scope.selectedArray.length === $scope.jsonObj.length) {
                    $scope.selectedArray = [];
                } else {
                    $scope.selectedArray = [].concat($scope.jsonObj);
                }
            };
            /**
             * [selectRow description] 选中行
             * @param  {[type]} row [description] 被选中的行
             * @return {[type]}     [description]
             */
            $scope.selectRow = function(row) {
                $scope.selectedArray = $scope.selectedArray ? $scope.selectedArray : [];
                var selectInfo = $scope.isSelected(row);
                if (selectInfo.flag) {
                    $scope.selectedArray.splice(selectInfo.index, 1);
                } else {
                    $scope.selectedArray.push(angular.copy(row));
                }
                //if ($scope.isSelected) {} else {}
            };
            /**
             * [batDelete description] 批量删除行
             * @return {[type]} [description]
             */
            $scope.batDeleteRow = function() {
                for (var i = $scope.jsonObj.length - 1; i >= 0; i--) {
                    var flag = false;
                    var index;
                    var rowIds = getRowIds($scope.jsonObj[i]); //$scope.jsonObj[];
                    for (var j in $scope.selectedArray) {
                        var row_ids = getRowIds($scope.selectedArray[j]);
                        if (rowIds === row_ids) {
                            flag = true;
                        }
                    }
                    if (flag) {
                        $scope.jsonObj.splice(i, 1);
                    }
                }
            };
            /**
             * [isSelected description] 指定行是否被选中
             * @param  {[type]}  row [description] 指定行
             * @return {Boolean}     [description]
             */
            $scope.isSelected = function(row) {
                var flag = false;
                var index;
                var rowIds = getRowIds(row);
                for (var i in $scope.selectedArray) {
                    var row_ = $scope.selectedArray[i];
                    var row_Ids = getRowIds(row_);
                    if (rowIds === row_Ids) {
                        flag = true;
                        index = i;
                    }
                }
                return {
                    flag: flag,
                    index: index
                };
            };
            /**
             * [getRowIds description] 获取行所包含稿件的id集合
             * @param  {[type]} theRow [description] 指定行
             * @return {[type]}        [description]
             */
            function getRowIds(theRow) {
                return theRow.map(function(value, index) {
                    return value.metadataId;
                }).sort(function(x, y) {
                    return x - y;
                }).join(",");
            }
            $scope.dragoverCallback = function(event, index, external, type) {
                $scope.logListEvent('dragged over', event, index, external, type);
                // Disallow dropping in the third row. Could also be done with dnd-disable-if.
                return true;
            };

            $scope.dropCallback = function(event, index, item, external, type, allowedType) {
                $scope.logListEvent('dropped at', event, index, external, type);
                if (external) {
                    if (allowedType === 'colType' && !item.label) return false;
                    if (allowedType === 'rowType' && !angular.isArray(item)) return false;
                }
                return item;
            };

            $scope.logEvent = function(message, event) {
                /*console.log(message, '(triggered by the following', event.type, 'event)');
                console.log(event);*/
            };
            $scope.dragend = function(message, event) {
                var i = $scope.jsonObj.length - 1;
                while (i >= 0) {
                    var array = $scope.jsonObj[i];
                    if (array.length === 0) {
                        $scope.jsonObj.splice(i, 1);
                    }
                    i--;
                }
            };
            $scope.logListEvent = function(action, event, index, external, type) {
                /*var message = external ? 'External ' : '';
                message += type + ' element is ' + action + ' position ' + index;
                $scope.logEvent(message, event);*/
            };
            $scope.countTitle = function(items) {
                // console.log(items);
                var len = 0;
                angular.forEach(items, function(value, key) {
                    var str = value.title.replace(/\<\/?[A-Za-z]+(.*?)\>/g, "");
                    for (var i = 0; i < str.length; i++) {
                        var data = str[i];
                        if (data.match(/[\u0000-\u00ff]/g)) len += 0.5;
                        else if (data.match(/[\u4e00-\u9fa5]|[！￥……（）——【】：“”‘’？《》？、·。，]/g)) len++;
                        else if (data.match(/[\uff00-\uffff]/g)) len++;
                        else if (data.match(/ /g)) len += 0.5;
                        else if (data.match(/　/g)) len++;
                    }
                });
                return len;
            };
            //每列div显示宽度计算

            $scope.limitSize = function(parent) {
                var outerLiWidth = $(".multidoc-tablebody-titleul").eq(0).width();
                var different = 40 / parent.items.length - 2;
                var divWidth = (outerLiWidth / parent.items.length - different) > 20 ? (outerLiWidth / parent.items.length - different) : 20;
                return "width:" + (divWidth-10) + "px";
                //$scope.limitSizeList[index] = "width:" + divWidth + "px";
                //console.log($(".outerli_" + index));
                //$scope.limitSizeList[index] = [];
            };
            //h5拖拽结束
            //工具条函数开始
            $scope.getToolBar = function(state, obj) {
                var tagName = $(obj.target)[0].tagName;
                if (state == "in") {
                    $(obj.target).closest("li").find("div").find("div").show();
                } else if (state == "out") {
                    $(obj.target).closest("li").find("div").find("div").hide();
                }
            };
            //工具条函数结束
            //行列字数自适应结束
            function init() {
                $scope.nowTime = fragmentService.getNowTime();
            }
        }
    };
}]);